/***
 *
 *   HOME NAV
 *   Navigation used on the main external website. Renders a dashboard link
 *   if the user is signed in, or a sign up link if they are not
 *
 **********/

import React from 'react';
import {
  Content,
  ClassHelper,
} from 'components/lib';
import Style from './home.tailwind.js';
import Logo from './../../../assets/salesblink-icon-logo.png';

export function HomeNav(props) {
  const css = ClassHelper(Style, {
    wrapper: true,
    color: !props.transparent,
    transparent: props.transparent,
  });

  return (
    <section className={css}>
      <Content>
        <div
          style={{ display: 'flex', justifyContent: 'center', paddingTop: 30 }}
        >
          <img alt="SalesBlink" src={Logo} style={{ width: 250 }} />
        </div>
      </Content>
    </section>
  );
}
